<!--
// FOR VNEXT-1726
// DROP DOWN FIELDS CAN NO LONGER BE SELECTED IN THE FORM BUILDER
// Existing uses of it remain and function, you just can't create a new one in Forms Templates anymore
// FLEX FIELDS ARE NOW TO BE USED FOR ALL MULTI-SELECT FUNCTIONALITY
-->

<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>



<ng-template #singleDropDown>
  @if (this.AutocompleteEnabled && !this.IsDesign) {
    <div>
      <app-autocomplete #singledropdownauto
        [title]="this.DropDownOptionsTitle"
        (selectedItems)="selectChange($event)"
        (onBlur)="this.blurValidation()">
      </app-autocomplete>
    </div>
  } @else {
    <div>
      @if (this.Mode === 'design') {
        <div class="flex-row-top-right">
          <div class="fill-remaining-space">
            <!-- If there are instructions, display label first, then instructions then field -->
            @if (this.HasInstructions) {
              @if (this.DisplayName) {
                <div class="design-mode-field-label">{{this.DisplayName}} @if (this.FormField.required) {
                  <span style="color: #EF0000;">*</span>
                }</div>
              }
              <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
            }
            <div>
              <mat-form-field appearance="outline" class="dropdown-mat-form-field">
                @if (this.ShowLabel && !HasInstructions) {
                  <mat-label class="design-mode-field-label">{{this.DisplayName}} @if (this.FormField.required) {
                    <span style="color: #EF0000;">*</span>
                  }</mat-label>
                }
                <mat-select disabled [(ngModel)]="this.DefaultDropdownValue">
                  <mat-option [value]="-1">
                    {{this.DefaultDropdownValueText}}
                  </mat-option>
                  @for (hshOption of this.ConfiguredOptions; track hshOption) {
                    <mat-option
                      [value]="hshOption.OptionId"
                      title="{{hshOption.OptionText}}">
                      {{hshOption.OptionText}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
          </div>
          <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
        </div>
      }
      @if ((this.Mode === 'preview') || (this.Mode === 'instance')) {
        <div
          class="flex-row-top-right">
          <div class="fill-remaining-space">
            @if (this.FormGroup !== null) {
              <!-- If there are instructions, display label first, then instructions then field -->
              @if (this.HasInstructions) {
                @if (this.DisplayName) {
                  <div class="field-label">{{this.DisplayName}} @if (this.FormField.required) {
                    <span style="color: #EF0000;">*</span>
                  }</div>
                }
                <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
              }
              <form [formGroup]="this.FormGroup">
                <mat-form-field appearance="outline"
                  [floatLabel]="'always'"
                  [hideRequiredMarker]="true"
                  class="dropdown-mat-form-field">
                  <!-- If there are no instructions, display label integrated into the field -->
                  @if (this.ShowLabel && !this.HasInstructions && !FieldIsInGrid) {
                    <mat-label
                      class="field-label">{{this.DisplayName}} @if (this.FormField.required) {
                      <span style="color: #EF0000;">*</span>
                    }</mat-label>
                  }
                  <mat-select formControlName="dropdown_form"
                    [disabled]="this.ReadOnly"
                    (blur)="this.handleValidationOnBlur()">
                    @for (strSelectOption of this.SelectOptions; track strSelectOption) {
                      <mat-option
                        title="{{strSelectOption}}"
                        [value]="strSelectOption">
                        {{strSelectOption}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </form>
            }
            @if ((! this.SelectOptions) || (this.SelectOptions.length === 0)) {
              <span>This control has no select options defined</span>
            }
            <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
          </div>
          <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
        </div>
      }
    </div>
  }
  <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
</ng-template>

<div class="outer-div">
  <div class="flex-row-top-right">

    <div class="fill-remaining-space">
      <ng-template [ngTemplateOutlet]="singleDropDown"></ng-template>
    </div>

    <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
  </div>
</div>

